import { render } from "./component-adress-type-el-region.vue?vue&type=template&id=874603cc"
import script from "./component-adress-type-el-region.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-type-el-region.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-type-el-region.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "874603cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('874603cc', __exports__)) {
    api.reload('874603cc', __exports__)
  }
  
  module.hot.accept("./component-adress-type-el-region.vue?vue&type=template&id=874603cc", () => {
    api.rerender('874603cc', render)
  })

}


export default __exports__